import { AaasModalNames } from '@va/aaas/shared/constants';
import { isModalOpen } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { fontWeights, Heading4, Paragraph } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import { useSelector } from 'react-redux';
import { AaasSubscriptionEndedActionButtons } from '../AaasFreeTrialEnded/AaasFreeTrialEndedModal';

export const AaasSubscriptionEndedModal_AccountSubscription_NoFreePlan = () => {
  const isOpen = useSelector((state) =>
    isModalOpen(state, AaasModalNames.subscriptionEnded_accountSubscription_noFreePlan),
  );
  const translate = useTranslate();

  return (
    <ModalWrapper
      className='bg-black-lighter-84! backdrop-blur-2px'
      closeOnBackdropClick={false}
      isModalOpen={isOpen}
      closeModal={() => {}}
    >
      <div className='max-w-[45rem] sm:p-3 sm:pt-18px p-24px pt-6 overflow-hidden text-center'>
        <div>
          <Heading4 className='mb-6px' weight={fontWeights.semibold}>
            {translate('aaas.modals.subscriptionEnded.accountSubscription.title')}
          </Heading4>
          <Paragraph className='mb-3' variant='display' variantSize='regular' weight={fontWeights.semibold}>
            {translate('aaas.modals.subscriptionEnded.accountSubscription.subtitle')}
          </Paragraph>

          <Paragraph weight={fontWeights.semibold}>
            {translate('aaas.modals.subscriptionEnded.accountSubscription.line1')}
          </Paragraph>
        </div>

        <AaasSubscriptionEndedActionButtons
          modalName={AaasModalNames.subscriptionEnded_accountSubscription_noFreePlan}
        />
      </div>
    </ModalWrapper>
  );
};
